import type {
  EventDate,
  EventDescription,
  Pricings,
} from '~/composables/types/event'
import type { GiftcardCartItem } from '~/composables/types/cart'

const parseGiftcardToCartItem = (
  event: EventDescription,
  selectedTicketQuantity: number,
  selectedTime: Ref<EventDate | undefined> | undefined = undefined,
  pricings: Pricings,
  giftcardType: 'VALUE' | 'EVENT' | 'SPECIAL'
): GiftcardCartItem => {
  return {
    type: 'GIFT_CARD',
    id: eventGetters.getId(event),
    giftcardId: eventGetters.getId(event),
    eventDescriptionId: eventGetters.getId(event) || '',
    title: eventGetters.getTitle(event),
    children: selectedTime?.value?.children || { data: [] },
    pricings,
    thumbnail: eventGetters.getFirstThumb(event),
    quantity: selectedTicketQuantity,
    permalink: eventGetters.getPermalink(event),
    availableTicketsQuantity:
      selectedTime?.value?.availableTicketsQuantity || undefined,
    startTime: selectedTime?.value?.start || undefined,
    endTime: selectedTime?.value?.end || undefined,
    giftcardType,
    giftcardAddon: 'PDF',
    supplier: eventGetters.getSupplierName(event),
  }
}

export default parseGiftcardToCartItem
